import clsx from 'clsx'

import {
  Pagination,
  PaginationContent,
  PaginationItem,
  PaginationLink,
  PaginationNext,
  PaginationPrevious,
} from 'shadcdn/ui/pagination'

export const AdminSoftwarePagination = (props: {
  page: number
  setPage: (page: number) => void
  pagesCount: number
  className?: string
}) => {
  const { page, setPage, pagesCount, className } = props
  return (
    <Pagination className={className}>
      <PaginationPrevious onClick={() => setPage(Math.max(page - 1, 0))} className="cursor-pointer" />

      <PaginationContent>
        {Array.from({ length: pagesCount }, (_, i) => (
          <PaginationItem key={i}>
            <PaginationLink
              onClick={() => setPage(i)}
              isActive={i === page}
              className={clsx({
                'cursor-pointer': i !== page,
                'bg-white': i === page,
                'font-bold': i === page,
              })}
            >
              {i + 1}
            </PaginationLink>
          </PaginationItem>
        ))}
      </PaginationContent>

      <PaginationNext onClick={() => setPage(Math.min(page + 1, pagesCount - 1))} className="cursor-pointer" />
    </Pagination>
  )
}
